/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Orientation_NumberInputs */

const cs_form_orientation_number = /** @type {(inputs: Form_Orientation_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo orientační (č.o.)`)
};

const en_form_orientation_number = /** @type {(inputs: Form_Orientation_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orientation number (č.o.)`)
};

/**
* | output |
* | --- |
* | "Orientation number (č.o.)" |
*
* @param {Form_Orientation_NumberInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_orientation_number = /** @type {((inputs?: Form_Orientation_NumberInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Orientation_NumberInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_orientation_number(inputs)
	return cs_form_orientation_number(inputs)
});